var Promise = monaco.Promise;
import * as gcService from '@greycat/lang-vscode-languageservice';
import * as ls from 'vscode-languageserver-types';
var GreyCatWorker = /** @class */ (function () {
    function GreyCatWorker(ctx, createData) {
        this._ctx = ctx;
        this._languageSettings = createData.languageSettings;
        this._languageId = createData.languageId;
        this._languageService = gcService.getGreyCatLanguageService();
        this._languageService.addTypes(createData.types);
        this._languageService.addFunctions(createData.functions);
    }
    // --- language service host ---------------
    GreyCatWorker.prototype.doValidation = function (uri) {
        var document = this._getTextDocument(uri);
        if (document) {
            var gcr = this._languageService.doParse(document);
            var diagnostics = this._languageService.doValidation(document, gcr, this._languageSettings);
            return Promise.as(diagnostics);
        }
        return Promise.as([]);
    };
    GreyCatWorker.prototype.doComplete = function (uri, position) {
        var document = this._getTextDocument(uri);
        if (document) {
            var gcr = this._languageService.doParse(document);
            var completions = this._languageService.doComplete(document, position, gcr);
            return Promise.as(completions);
        }
        return Promise.as({ isIncomplete: false, items: [] });
    };
    GreyCatWorker.prototype.doHover = function (uri, position) {
        var document = this._getTextDocument(uri);
        var hover = null;
        if (document) {
            var gcr = this._languageService.doParse(document);
            hover = this._languageService.doHover(document, position, gcr);
        }
        return Promise.as(hover);
    };
    GreyCatWorker.prototype._getTextDocument = function (uri) {
        var models = this._ctx.getMirrorModels();
        for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
            var model = models_1[_i];
            if (model.uri.toString() === uri) {
                return ls.TextDocument.create(uri, this._languageId, model.version, model.getValue());
            }
        }
        return null;
    };
    return GreyCatWorker;
}());
export default GreyCatWorker;
export function create(ctx, createData) {
    return new GreyCatWorker(ctx, createData);
}
//# sourceMappingURL=gcWorker.js.map